import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostsKey } from '../../utils/keys';
export const useReplies = (options) => {
    const { variables, fields = 'default', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const repliesKey = getPostsKey(variables);
    return useInfiniteQuery(repliesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.posts.replies({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useReplies.js.map